import { render, staticRenderFns } from "./PivotGridIcon.vue?vue&type=template&id=77aff5f2&"
import script from "./PivotGridIcon.vue?vue&type=script&lang=js&"
export * from "./PivotGridIcon.vue?vue&type=script&lang=js&"
import style0 from "./PivotGridIcon.vue?vue&type=style&index=0&id=77aff5f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports